import {
  Alert,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconAlertCircle } from "@tabler/icons-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";

export function LoginPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const form = useForm({
    initialValues: { username: "", password: "" },
    validate: {
      username: (v) => (v.trim().length === 0 ? "Логин обязателен" : null),
      password: (v) => (v.length === 0 ? "Пароль обязателен" : null),
    },
  });

  const loginMutation = useMutation({
    mutationFn: ({ username, password }: { username: string; password: string }) =>
      api.login(username, password),
    onSuccess: () => {
      // Сбросить все query — особенно ['me'], чтобы AuthGate перерендерился авторизованным.
      queryClient.invalidateQueries();
      navigate("/", { replace: true });
    },
  });

  return (
    <Center mih="100vh" px="md">
      <Paper shadow="sm" p="xl" radius="md" w={420} withBorder>
        <Stack gap="md">
          <Stack gap={4}>
            <Title order={2}>🧩 MetaTRIZ</Title>
            <Text c="dimmed" size="sm">
              Вход в систему. Сессия живёт 30 дней.
            </Text>
          </Stack>

          <form
            onSubmit={form.onSubmit((values) => loginMutation.mutate(values))}
            autoComplete="on"
          >
            <Stack gap="sm">
              <TextInput
                label="Логин"
                autoComplete="username"
                {...form.getInputProps("username")}
              />
              <PasswordInput
                label="Пароль"
                autoComplete="current-password"
                {...form.getInputProps("password")}
              />

              {loginMutation.isError && (
                <Alert
                  icon={<IconAlertCircle size={16} />}
                  color="red"
                  variant="light"
                >
                  {String(loginMutation.error)}
                </Alert>
              )}

              <Button type="submit" loading={loginMutation.isPending} fullWidth mt="xs">
                Войти
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Center>
  );
}
